import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useSettingsStore } from '@core/store';
import { WcnButton } from '@/components';

interface DeleteConfirmationDialogProps {
    open: boolean;
    heading: string;
    message: string;
    onConfirm: () => void;
    onCancel: () => void;
    hideConfirm?: boolean;
}

export const DeleteConfirmationDialog: React.FC<DeleteConfirmationDialogProps> = ({
    open,
    heading,
    message,
    onConfirm,
    onCancel,
    hideConfirm = false
}) => {
    const { t } = useTranslation();
    const { darkMode } = useSettingsStore();

    return (
        <Dialog
            open={open}
            onClose={onCancel}
            maxWidth="sm"
            fullWidth
            PaperProps={{
                sx: {
                    bgcolor: darkMode ? 'var(--dark-bg-lighter)' : 'white',
                    color: darkMode ? 'white' : 'var(--gray-dark)'
                }
            }}
        >
            <DialogTitle
                sx={{
                    fontSize: '1.25rem',
                    fontWeight: 600,
                    wordBreak: 'break-word'
                }}
            >
                {heading}
            </DialogTitle>
            <DialogContent>
                <Typography
                    sx={{
                        wordBreak: 'break-word',
                        whiteSpace: 'pre-line'
                    }}
                >
                    {message}
                </Typography>
            </DialogContent>
            <DialogActions sx={{ p: 2 }}>
                {hideConfirm ? (
                    <WcnButton onClick={onCancel} variant="primary">
                        {t('ok')}
                    </WcnButton>
                ) : (
                    <>
                        <WcnButton onClick={onCancel} variant="primary">
                            {t('no')}
                        </WcnButton>
                        <WcnButton onClick={onConfirm} variant="red" color="error">
                            {t('yes')}
                        </WcnButton>
                    </>
                )}
            </DialogActions>
        </Dialog>
    );
};
